import { TitleCasePipe } from "@angular/common";


const titleCasePipe = new TitleCasePipe();

export class BudgetFilters {

  public staticFilters;
  public optionalFilters;

  constructor(private entities){


    this.staticFilters = [
      {
        entity: this.entities.budget.entity,
        field: {
          name: 'number',
          type: 'text',
          label: 'Número', //+titleCasePipe.transform(this.entities.budget.labels.form),
          width: 1
        }
      },
      {
        entity: this.entities.client.entity,
        field: {
          name: 'name',
          type: 'text',
          label: titleCasePipe.transform(this.entities.client.labels.form),
          width: 2
        }
      },
      {
        entity: this.entities.claim.entity,
        field: {
          name: 'number',
          type: 'text',
          label: 'Nº '+titleCasePipe.transform(this.entities.claim.labels.form),
          width: 2
        }
      },
      {
        entity: this.entities.budget.entity,
        field: {
          name: 'created_at',
          type: 'date',
          label: 'Creado',
          width: 2,
          from: true
        }
      },
    ]


  }
}

